import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, GraduationTypeOptions } from "../../../../../../_helpers/Helpers";

export function FamilyMemberEducationalBackgroundInfoForm({
  backgroundName,
  handleChange,
  setFieldValue,
  values
 }) {
  const graduationType = backgroundName + ".graduationType";
  const university = backgroundName + ".university";
  const department = backgroundName + ".department";
  const graduationYearId = backgroundName + ".graduationYear";
  const graduationYear = values.graduationYear != null ? values.graduationYear : "";

  return (
    <div className="row">
      <div className="col-6">
        <Form.Group as={Row} controlId={graduationType}>
          <Form.Label column sm={3}>
            Mezuniyet Türü
          </Form.Label>
          <Col sm={9}>
            <CustomSelect
              options={GraduationTypeOptions}
              value={values.graduationType}
              onChange={option => setFieldValue(graduationType, option.value)}
            />
          </Col>
        </Form.Group>
          
        <Form.Group as={Row} controlId={university}>
          <Form.Label column sm={3}>
            Üniversite
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.university} placeholder="Üniversite" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>

      <div className="col-6">
        <Form.Group as={Row} controlId={department}>
          <Form.Label column sm={3}>
            Bölüm
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="text" value={values.department} placeholder="Bölüm" onChange={handleChange} />
          </Col>
        </Form.Group>
                  
        <Form.Group as={Row} controlId={graduationYearId}>
          <Form.Label column sm={3}>
            Mezuniyet Yılı
          </Form.Label>
          <Col sm={9}>
            <Form.Control type="number" min={0} value={graduationYear} placeholder="Mezuniyet Yılı" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>
    </div>
  );
}